import {useState, useEffect} from 'react';
import search_icon from "../../assets/icons/search.svg"

import Navigation from "../navigation/Navigation";

import styleJSON from "../../assets/variables.json";

import Inputfield from '../customComponents/Inputfield';
import Dropdownlist from '../customComponents/Dropdownlist';

import Translations from '../adminPanel/Translations';
import Dashboard from "../adminPanel/Dashboard";

import styles from "../../assets/stylesheets/sass/AdminPanel.module.scss"

export default function AdminPanel({onLogout}){
let navigationData = {
    "admin": {
        "Dashboard": {
            "Dashboard": true
        },
		"Translations": {
            "Translations": true,
        },
        "Styling": {
            "Styling": true
        },
		"User Management": {
            "User Management": true
        }
    }
};
  	const [selectedPage, setselectedPage] = useState("Dashboard");

	useEffect(()=>{
		let keys = Object.keys(styleJSON);

		keys.forEach(key => {
		if(typeof(styleJSON[key]) === "object"){
			let subkkeys = Object.keys(styleJSON[key]);
			subkkeys.forEach(subkey => {
			document.getElementById('root').style.setProperty(`--${subkey}`, styleJSON[key][subkey])
			});
		}
		else{
			//console.log(styleJSON[key])
		}
		});
	}, [])

	const handleLogout = (v) =>{
		setselectedPage("Dashboard");
		window.sessionStorage.setItem("active_navigation_item", "Dashboard");
		onLogout(v);
	}

	return (
	    <div style={{display:"flex"}}>	
			{console.warn("This admin panel does not work yet, it is just a prototype. It needs a place to save the data on.")}
			<Navigation navigationData={navigationData} userRole={"admin"} selectedPage={(page)=>setselectedPage(page)} loggedOut={(v)=>{handleLogout(v)}} changeLanguage={(v)=>console.log(v)}/>
	    	<div className={styles.main}>
				<div className={styles.header}>
					<div style={{marginLeft:"2rem", width:"18rem"}}><Inputfield placeholder="Zoeken..." trailingIcon={search_icon} active/></div>
					<div style={{marginRight:"2rem"}}><Dropdownlist data={["Nederlands", "Frans", "Duits"]} defaultValue type="language" width="small"/></div>
				</div>
				{
					selectedPage === "Dashboard" ?
					<Dashboard />
					:
					selectedPage === "Translations" ?
					<Translations />
					: 
					<p>{selectedPage}</p>
				}
            </div>
	    </div>  
  	);
}